import { request } from '../../helpers/api/request';
import { FeedBody, FeedContract } from '../../types/Endpoints/feeds';

export const createFeed = async (requestBody: FeedBody) => {
    const { data } = await request<FeedContract>({
        method: 'POST',
        url: 'admin/feeds',
        data: requestBody,
    });

    return data;
};
